export function wait(milliseconds: number): Promise<void> {
    return new Promise<void>((resolve, _) => {
        setTimeout(() => {
            resolve();
        }, milliseconds);
    });
}

export function ErrorStringFromException(e): string {
    let exceptionString: string = "Exception: " + JSON.stringify(e);
    if (e.name)
        exceptionString += ", name: " + e.name;
    if (e.code)
        exceptionString += ", code: " + e.code;
    if (e.message)
        exceptionString += ", message: " + e.message;
    if (e.stack)
        exceptionString += ", stack: " + e.stack;

    return exceptionString;
}